import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
  @Input() eyebrow?: string;
  @Input() title!: string;
  @Input() description?: string;
  @Input() backLink?: string | any[];
  @Input() backAriaLabel = 'Back';
}
